export default {
  nameplate:{
    nameplateName:'铭牌名称',
    nameplateId:'铭牌ID',
    addNameplate:'添加铭牌',
    nameplateImg:'铭牌图片',
    nameplateSVGA:'铭牌特效',
    priority:'优先级',
    sort:'排序',

    tableText1:'拥有人数',
    tableText2:'创建人',
    createTime:'创建时间',
    grant:'发放'
  }
}



// WEBPACK FOOTER //
// ./src/language/nameplate-zh-cn.js